/* assets/cart-drawer-upsell.js */
(function () {
  'use strict';

  if (window.__CU_UPSELL_BOUND__) return;
  window.__CU_UPSELL_BOUND__ = true;

  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const EVENTS = {
    impression: 'sk_cart_upsell_impression',
    click: 'sk_cart_upsell_click',
    add: 'sk_cart_upsell_add'
  };

  const seenKeys = new Set();

  function getSessionId() {
    try {
      const key = 'sk_cart_upsell_session_id';
      let value = sessionStorage.getItem(key);
      if (!value) {
        value = 'ups_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
        sessionStorage.setItem(key, value);
      }
      return value;
    } catch (e) {
      return 'ups_' + Date.now();
    }
  }

  function getCurrencyCode() {
    return (
      window?.Shopify?.currency?.active ||
      window?.ACTIVE_CURRENCY?.code ||
      'USD'
    );
  }

  function getSelectedVariantId(card, btn) {
    const select = card?.querySelector('[data-upsell-variant-select]');
    if (select && select.value) return String(select.value);
    return String(btn.dataset.defaultVariantId || '');
  }

  function getSelectedVariantTitle(card) {
    const select = card?.querySelector('[data-upsell-variant-select]');
    if (!select) return '';
    const option = select.options[select.selectedIndex];
    return option ? option.text.trim() : '';
  }

  function getCardPosition(card) {
    if (!card || !card.parentElement) return 0;
    const cards = Array.from(card.parentElement.children).filter(function (el) {
      return el.classList.contains('cu-moreCard');
    });
    return Math.max(cards.indexOf(card) + 1, 1);
  }

  function buildPayload(card, btn, variantId) {
    return {
      placement: btn.dataset.placement || 'cart_drawer_you_may_also_like',
      source_mode: btn.dataset.sourceMode || 'fixed_collection',
      primary_source_product_id: btn.dataset.primarySourceProductId || '',
      primary_source_product_handle: btn.dataset.primarySourceProductHandle || '',
      primary_source_variant_id: btn.dataset.primarySourceVariantId || '',
      upsell_product_id: String(btn.dataset.productId || ''),
      upsell_product_title: btn.dataset.productTitle || '',
      upsell_product_handle: btn.dataset.productHandle || '',
      upsell_variant_id: String(variantId || ''),
      upsell_variant_title: getSelectedVariantTitle(card),
      currency: getCurrencyCode(),
      value: Number(btn.dataset.price || 0),
      upsell_value: Number(btn.dataset.price || 0),
      quantity: 1,
      position: getCardPosition(card),
      upsell_session_id: getSessionId()
    };
  }

  function pushToDataLayer(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...payload
    });
  }

  function publishCustomEvent(eventName, payload) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(eventName, payload);
      }
    } catch (e) {
      console.warn('[upsell publish error]', e);
    }
  }

  function trackEvent(eventName, payload) {
    pushToDataLayer(eventName, payload);
    publishCustomEvent(eventName, payload);
  }

  function setDrawerLoading(isLoading) {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.classList.toggle('is-loading', !!isLoading);
  }

async function addVariant(variantId, qty, properties) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      items: [
        {
          id: Number(variantId),
          quantity: qty,
          properties: properties
        }
      ],
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
  });

  if (!response.ok) throw new Error('cart/add.js failed');
  return response.json();
}

  function replaceCartIconBubbleFromHTML(html) {
    try {
      if (!html) return;

      const wrap = document.createElement('div');
      wrap.innerHTML = html;

      const newSection = wrap.querySelector('#shopify-section-cart-icon-bubble');
      const oldSection = document.querySelector('#shopify-section-cart-icon-bubble');

      if (newSection && oldSection) {
        oldSection.replaceWith(newSection);
        return;
      }

      const newEl = wrap.querySelector('#cart-icon-bubble');
      const oldEl = document.querySelector('#cart-icon-bubble');
      if (newEl && oldEl) {
        oldEl.replaceWith(newEl);
        return;
      }

      const newCount = wrap.querySelector('.cart-count-bubble');
      const oldCount = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (newCount && oldCount) oldCount.replaceWith(newCount);
    } catch (e) {
      console.warn('[upsell bubble replace]', e);
    }
  }

  function setCartBubbleCount(count) {
    try {
      count = Number(count || 0);

      const bubbleRoot = document.querySelector('#cart-icon-bubble');
      if (!bubbleRoot) return;

      let existing = bubbleRoot.querySelector('.cart-count-bubble');

      if (count <= 0) {
        if (existing) existing.remove();
        return;
      }

      if (!existing) {
        existing = document.createElement('div');
        existing.className = 'cart-count-bubble';
        bubbleRoot.appendChild(existing);
      }

      existing.innerHTML =
        '<span aria-hidden="true">' + count + '</span>' +
        '<span class="visually-hidden">' + count + ' item' + (count === 1 ? '' : 's') + '</span>';
    } catch (e) {
      console.warn('[upsell bubble count]', e);
    }
  }

  async function refreshCartBubbleFromCartJS() {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    const response = await fetch(root + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) throw new Error('cart.js failed');

    const cart = await response.json();
    setCartBubbleCount(cart.item_count);
  }

  function refreshDrawer(sections) {
    const currentDrawer = document.querySelector('#CartDrawer');
    const currentDrawerInner = document.querySelector('#CartDrawer .drawer__inner');

    const parsedDoc = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
    const newDrawer = parsedDoc.querySelector('#CartDrawer');
    const newDrawerInner = parsedDoc.querySelector('#CartDrawer .drawer__inner');

    if (currentDrawer && newDrawer) {
      currentDrawer.className = newDrawer.className;
    }

    if (currentDrawerInner && newDrawerInner) {
      currentDrawerInner.replaceWith(newDrawerInner);
    }

    const drawerEl = document.querySelector('#CartDrawer');
    if (drawerEl && typeof drawerEl.open === 'function') {
      drawerEl.open();
    }

    bindUpsellImpressions();
  }

  async function refreshAllFallback() {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    const url = root + 'cart?sections=' + encodeURIComponent(SECTIONS.join(','));

    const response = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) throw new Error('sections fallback failed');

    const sections = await response.json();

    if (sections['cart-drawer']) refreshDrawer(sections);

    if (sections['cart-icon-bubble']) {
      replaceCartIconBubbleFromHTML(sections['cart-icon-bubble']);
    } else {
      await refreshCartBubbleFromCartJS();
    }
  }

  function startLoading(btn) {
    if (btn.dataset.loading === '1') return false;

    btn.dataset.loading = '1';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    if (!btn.dataset.originalHtml) {
      btn.dataset.originalHtml = btn.innerHTML;
    }

    btn.innerHTML = '<span class="cu-add-btn-text">ADDING…</span>';
    setDrawerLoading(true);
    return true;
  }

  function stopLoading(btn) {
    btn.dataset.loading = '0';
    btn.disabled = false;
    btn.removeAttribute('aria-busy');

    if (btn.dataset.originalHtml) {
      btn.innerHTML = btn.dataset.originalHtml;
    }

    setDrawerLoading(false);
  }

  function buildLineItemProperties(payload) {
    return {
      _upsell: 'true',
      _upsell_source: 'cart_drawer',
      _upsell_source_mode: payload.source_mode || '',
      _upsell_placement: payload.placement || '',
      _upsell_product_id: payload.upsell_product_id || '',
      _upsell_product_handle: payload.upsell_product_handle || '',
      _upsell_variant_id: payload.upsell_variant_id || '',
      _upsell_variant_title: payload.upsell_variant_title || '',
      _upsell_item_name: payload.upsell_product_title || '',
      _upsell_price: String(payload.value || ''),
      _upsell_primary_source_product_id: payload.primary_source_product_id || '',
      _upsell_primary_source_product_handle: payload.primary_source_product_handle || '',
      _upsell_primary_source_variant_id: payload.primary_source_variant_id || '',
      _upsell_position: String(payload.position || ''),
      _upsell_session_id: payload.upsell_session_id || ''
    };
  }

  function bindUpsellImpressions() {
    const root = document.querySelector('#CartDrawer [data-cu-more-root]');
    if (!root) return;

    const cards = root.querySelectorAll('.cu-moreCard');
    if (!cards.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          const card = entry.target;
          const btn = card.querySelector('[data-upsell-add]');
          if (!btn) return;

          const variantId = getSelectedVariantId(card, btn);
          const key = String(btn.dataset.productId || '') + ':' + String(variantId || '');

          if (seenKeys.has(key)) return;
          seenKeys.add(key);

          trackEvent(EVENTS.impression, buildPayload(card, btn, variantId));
          observer.unobserve(card);
        });
      },
      { threshold: 0.5 }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  document.addEventListener('click', async function (evt) {
    const link = evt.target.closest('[data-upsell-link]');
    if (link && link.closest('#CartDrawer [data-cu-more-root]')) {
      const card = link.closest('.cu-moreCard');
      const btn = card && card.querySelector('[data-upsell-add]');
      if (btn) {
        const variantId = getSelectedVariantId(card, btn);
        trackEvent(EVENTS.click, buildPayload(card, btn, variantId));
      }
      return;
    }

    const btn = evt.target.closest('[data-upsell-add]');
    if (!btn || !btn.closest('#CartDrawer')) return;

    evt.preventDefault();
    evt.stopPropagation();

    const card = btn.closest('.cu-moreCard');
    const variantId = getSelectedVariantId(card, btn);

    if (!variantId) return;
    if (!startLoading(btn)) return;

    const payload = buildPayload(card, btn, variantId);
    const lineItemProperties = buildLineItemProperties(payload);

    try {
      const data = await addVariant(variantId, 1, lineItemProperties);

      trackEvent(EVENTS.add, payload);

      if (data.sections) {
        if (data.sections['cart-drawer']) refreshDrawer(data.sections);

        if (data.sections['cart-icon-bubble']) {
          replaceCartIconBubbleFromHTML(data.sections['cart-icon-bubble']);
        } else {
          await refreshCartBubbleFromCartJS();
        }
      } else {
        await refreshAllFallback();
      }

      if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'upsell' });
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      console.error('[upsell add]', err);

      try {
        await refreshAllFallback();
      } catch (fallbackErr) {
        console.error('[upsell fallback]', fallbackErr);
      }
    } finally {
      stopLoading(btn);
    }
  });

  bindUpsellImpressions();
})();